
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MaterialReturnItemsGrid extends Serenity.EntityGrid<MaterialReturnItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.MaterialReturnItems'; }
        protected getDialogType() { return MaterialReturnItemsDialog; }
        protected getIdProperty() { return MaterialReturnItemsRow.idProperty; }
        protected getInsertPermission() { return MaterialReturnItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialReturnItemsRow.localTextPrefix; }
        protected getService() { return MaterialReturnItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}